export const Theme = {
  primaryBody: "#000000", //Black
  secondaryBody: "rgb(42, 41, 41)", //Dark grey#383838
  lightGrey: "#EEEEEE", //very light grey
  blue: "#2FA4FF", //vivid blue
  white: "#ffffff", //white
};

